import React from 'react';
import PreviewImageSection from 'components/common/element-data/sections/PreviewImageSection';
import SummarySection from 'components/common/element-data/sections/SummarySection';
import GlossaryTermsSection from 'components/common/element-data/sections/GlossaryTermsSection';
import DetailsSection from 'components/common/element-data/sections/DetailsSection';
import RelatedDrillDownSection from 'components/common/element-data/sections/RelatedDrillDownSection';
import RelatedLinkedReportsSection from 'components/common/element-data/sections/RelatedLinkedReportsSection';
import CustomFieldsSection from 'components/common/element-data/sections/CustomFieldsSection';
import DocumentsSection from 'components/common/element-data/sections/DocumentsSection';
import ElementDataContainer, { ElementDataContainerSize } from 'components/common/element-data/ElementDataContainer';
import { IElementData, IElementDataSettings } from 'components/common/element-data/types';

interface ElementDataInfoProps {
    elementData: IElementData;
    elementDataSettings?: IElementDataSettings;
    size?: ElementDataContainerSize;
    showHeader?: boolean;
    viewMods?: string[];
}
export default function ElementDataInfo(props: ElementDataInfoProps) {
    const { elementData, elementDataSettings } = props;

    return (
        <ElementDataContainer {...props}>
            <PreviewImageSection {...elementData} settings={elementDataSettings} />
            <SummarySection {...elementData} settings={elementDataSettings} />
            <GlossaryTermsSection {...elementData} settings={elementDataSettings} />
            <DetailsSection {...elementData} settings={elementDataSettings} />
            <RelatedDrillDownSection {...elementData} settings={elementDataSettings} />
            <RelatedLinkedReportsSection {...elementData} settings={elementDataSettings} />
            <CustomFieldsSection {...elementData} settings={elementDataSettings} />
            <DocumentsSection {...elementData} settings={elementDataSettings} />
        </ElementDataContainer>
    );
}
